import { useState } from 'react';
import { Step } from 'types/wizard';
import { FlowType } from 'types/template';

export const useWizardSteps = (selectedFlow: FlowType) => {
  const baseSteps: Step[] = [
    {
      id: 1,
      label: 'Select Starting Point',
      pageTitle: 'Select Starting Point',
      pageSubTitle: 'Choose how you want to create your team site',
    },
  ];

  const existingFlowSteps: Step[] = [
    {
      id: 2,
      label: 'Choose a template',
      pageTitle: 'Choose from Existing Templates',
      pageSubTitle:
        'Select from existing Teams templates to get started',
        // NOTE (5/7/2025): Commenting this out, as the teams_integration repo hasn't been updated
        //'Select from existing Teams or PRATUS templates to get started',
    },
    {
      id: 3,
      label: 'Launch',
      pageTitle: 'Launch Your Template',
      pageSubTitle: 'Review and launch your selected template',
    },
  ];

  const newFlowSteps: Step[] = [
    {
      id: 2,
      label: 'Configure Your Teams',
      pageTitle: 'Configure Your Teams',
      pageSubTitle: 'Define the structure and settings for your new template.',
    },
    {
      id: 3,
      label: 'Add Channels',
      pageTitle: 'Add Channels',
      pageSubTitle: "Customize channels to align with your team's workflow.",
    },
    {
      id: 4,
      label: 'Preview & Launch',
      pageTitle: 'Preview & Launch',
      pageSubTitle:
        'Finalize your setup by checking that all components are properly in place and ready for action.',
    },
  ];

  const steps = [
    ...baseSteps,
    ...(selectedFlow === 'existing' ? existingFlowSteps : newFlowSteps),
  ];

  const [activeStep, setActiveStep] = useState(steps[0]);

  const incrementStepTransition = (currentStep: Step) => {
    const nextStep = steps.find((step) => step.id === currentStep.id + 1);
    if (nextStep) {
      setActiveStep(nextStep);
    } else {
      throw new Error('No next step provided');
    }
  };

  return {
    steps,
    activeStep,
    setActiveStep,
    incrementStepTransition,
  };
};
